import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/**
 * Floating "back to top" arrow visible after the user scrolls ≥600px
 * down the window. Clicking it smoothly scrolls back to top. Sits in
 * the fixed bottom-right corner so it never overlaps content; auto-
 * hides while at the top so it doesn't add visual noise on short pages.
 */
export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Appears once the user has scrolled ≥ 300px down — low enough that
    // it shows up on most pages that need it, high enough not to clutter
    // short pages where 'back to top' is trivially close anyway.
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top"
      aria-label="back to top"
      title="back to top"
      className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40 w-11 h-11 flex items-center justify-center bg-sumi text-washi border border-sumi hover:bg-shu hover:border-shu transition-colors shadow-md"
    >
      <ArrowUp size={18} strokeWidth={2} />
    </button>
  );
}
